<template>
<p v-if="documentsCount >= 0">
  Нажимая на кнопку, вы соглашаетесь с
  <template v-for="(doc, index) in documents">
    <router-link :key="`legal-document-link-${doc.id}`" :to="doc.route" target="_blank">{{ doc.name }}</router-link>
    <template v-if="index < documentsCount">{{ index < documentsCount - 1 ? ', ' : ' и ' }}</template>
  </template>.
</p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      settings: 'settings/legalDocs',
    }),

    documents() {
      const documents = []

      if (this.settings.personal_data) {
        documents.push({
          id: 'personal-data-policy',
          name: 'политикой обработки персональных данных',
          route: { name: 'legal-personal-data-policy' },
        })
      }

      if (this.settings.privacy_policy) {
        documents.push({
          id: 'privacy-policy',
          name: 'политикой конфиденциальности',
          route: { name: 'legal-privacy-policy' },
        })
      }

      if (this.settings.eula) {
        documents.push({
          id: 'eula',
          name: 'пользовательским соглашением',
          route: { name: 'legal-eula' },
        })
      }

      return documents
    },

    documentsCount() {
      return this.documents.length - 1
    },
  },
}
</script>
